import { skipToken, useQuery } from "@tanstack/react-query"
import { usersKeys } from "./queryKeys"
import { getSlackUsernames, getToken, getUserByEmail } from "./users"
import { MS_IN_DAY } from "@constants"
import { useAuth0 } from "@auth0/auth0-react"
import { useAuthToken } from "@hooks/useAuthToken"

export const useAuthUserDetails = () => {
  const { user } = useAuth0()
  // We added this check (isTokenConfigured) to the queryFn because useAuthUserDetails is used in useAuditInterceptor,
  // and useAuditInterceptor is used in AxiosInterceptorWrapper, which is rendered before the axios token is configured
  // using the useAuthToken hook.
  const { isTokenConfigured } = useAuthToken()
  const email = user?.email
  return useQuery({
    queryKey: usersKeys.detail(email),
    queryFn:
      email && isTokenConfigured ? () => getUserByEmail(email) : skipToken,
    staleTime: MS_IN_DAY,
    meta: {
      persist: true,
    },
  })
}

export const useGetToken = (token: string | undefined) => {
  return useQuery({
    queryKey: usersKeys.token(token),
    queryFn: token ? () => getToken(token) : skipToken,
    staleTime: MS_IN_DAY,
    meta: {
      // We don't have a clear use case for persisting the token.
      // Plus it creates multiple key records due to Auth0 refreshing token on each browser refresh (this is expected behavior)
      persist: false,
    },
  })
}

export const useGetSlackUsernamesQuery = () => {
  return useQuery({
    queryKey: usersKeys.slackUsernames(),
    queryFn: () => getSlackUsernames(),
  })
}
